// صفحة مهام مياسة - التصميم والمنطق موحّدين بـ components/EmployeeTasksPage.jsx
import React from "react";
import EmployeeTasksPage from "./components/EmployeeTasksPage";

const MaysaTasks = () => (
  <EmployeeTasksPage employeeName="مياسة" title="مياسة" backPath="/maysa-dashboard" />
);

export default MaysaTasks;
